import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  templates: [],
});

const templateSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setTemplates: (state, action) => {
      localStorage.setItem('templates', JSON.stringify(action.payload));
      state.templates = action.payload;
    },
  },
});

export const { setTemplates } = templateSlice.actions;

export default templateSlice.reducer;
